import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material';
import {ImageService} from '../../../shared/services/image.service';

@Component({
    selector: 'app-disclosure-itc-dialog',
    templateUrl: './disclosure-itc-dialog.component.html',
    styleUrls: ['./disclosure-itc-dialog.component.scss']
})
export class DisclosureItcDialogComponent implements OnInit {
    closeIcon: string;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private imageService: ImageService) {
        this.closeIcon = imageService.getImage('CLOSE-ICON');
    }

    ngOnInit() {
    }
}
